var blockBundles;

try {
  blockBundles = {
    taydu_dangkytruoc: {
      content: {
        game: {
          html: require("../../taydu_dangkytruoc/game/game.html.twig"),
          scss: require("../../taydu_dangkytruoc/game/game.scss"),
          js: require("../../taydu_dangkytruoc/game/game.js"),
          dir: "taydu_dangkytruoc/game/game",
        }
      },
    }
  };
} catch (error) {
  console.log(error);
}

export default blockBundles;
